module.exports = __webpack_public_path__ + "static/media/youtube.4fd8f48f.svg";